<template>
    <div>
        <rkm-table
            :items="exames"
            :fields="fields.datatables.tipo"
            :filter="filter"
            sort-by="nome"
        >
            <template slot="filters">
                <rkm-row>
                    <rkm-col class="flex-grow-1">
                        <rkm-form-input
                            placeholder="Digite para buscar"
                            v-model="filter"
                        >
                            <rkm-input-group-prepend slot="prepend">
                                <rkm-input-group-text>Buscar</rkm-input-group-text>
                            </rkm-input-group-prepend>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            :disabled="!filter"
                            @click="handleClearFilter"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </template>

            <template v-slot:cell(nome)="row">
                <template v-if="row.item.codigo === null || row.item.codigo === ''">
                    {{row.item.nome}}
                </template>
                <template v-else>
                    {{ row.item.codigo }} - {{row.item.nome}}
                </template>
            </template>

            <template v-slot:cell(actions)="{ item }">
                  <rkm-button
                    @click.stop="$emit('deleteExame', item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    computed: {
        fields() {

            const fieldsTipo = [
                { key: 'nome', label: 'Exame', sortable: true },
            ]

            if (!this.hideActions) {

                fieldsTipo.push({ key: 'actions', label: 'Ações', class: 'col-min' })
            }

            return {
                datatables: {
                    tipo: fieldsTipo,
                }
            }
        },
    },
    data: () => ({
        items: [],
        filter: null,
    }),
    methods: {
        deletarExame(item){

            this.$emit('deleteExame', item)
        },
        handleClearFilter() {
            this.filter = null
        },
    },
    props: {
       exames: { type: Array, required: true },
       hideActions: { type: Boolean, default: false },
    },
}
</script>